{
  "IncludeintransitioningsequenceLabel": "Includi nella sequenza di visualizzazione di transizione del rapporto:",
  "RptdisplintervaltimeLabel": "Rapporto Intervallo di visualizzazione:",
  "RptdisplintervaltimePlaceholder": "5s",
  "DisplaySwitching_SectionHeader": "Commutazione automatica del display del report",
  "NAME": "DisplaySwitching"
}